/**
 * @file Index
 * @description
 * @author fex
 */

import NotFound from './404';
import {default as Alert, alert, confirm, prompt} from './Alert';
import {default as ContextMenu, openContextMenus} from './ContextMenu';
import AsideNav from './AsideNav';
import Button from './Button';
import Checkbox from './Checkbox';
import Checkboxes from './Checkboxes';
import Collapse from './Collapse';
import DatePicker from './DatePicker';
import DateRangePicker from './DateRangePicker';
import Drawer from './Drawer';
import {default as Tabs, Tab} from './Tabs';
import Editor from './Editor';
import Html from './Html';
import * as Icons from './icons';
import Layout from './Layout';
import LazyComponent from './LazyComponent';
import Modal from './Modal';
import Overlay from './Overlay';
import PopOver from './PopOver';
import Radios from './Radios';
import Range from './Range';
import Rating from './Rating';
// import RichText from './RichText';
import Select from './Select';
import SparkLine from './SparkLine';
import Spinner from './Spinner';
import Switch from './Switch';
import Textarea from './Textarea';
import TitleBar from './TitleBar';
import {default as ToastComponent, toast} from './Toast';
import Tooltip from './Tooltip';
import TooltipWrapper from './TooltipWrapper';
import Tree from './Tree';
import Alert2 from './Alert2';
import Transfer from './Transfer';
import TabsTransfer from './TabsTransfer';
import ListCheckboxes from './ListCheckboxes';
import TableCheckboxes from './TableCheckboxes';
import TreeCheckboxes from './TreeCheckboxes';
import ChainedCheckboxes from './ChainedCheckboxes';
import ResultBox from './ResultBox';
import InputBox from './InputBox';
import ListRadios from './ListRadios';
import TreeRadios from './TreeRadios';
import ListGroup from './ListGroup';
import NumberInput from './NumberInput';
import ArrayInput from './ArrayInput';
import SearchBox from './SearchBox';
import AnchorNav from './AnchorNav';

export {
  NotFound,
  Alert as AlertComponent,
  alert,
  confirm,
  prompt,
  ContextMenu,
  openContextMenus,
  Alert2,
  AsideNav,
  Button,
  Checkbox,
  Checkboxes,
  Collapse,
  DatePicker,
  DateRangePicker,
  Drawer,
  Tabs,
  Tab,
  Editor,
  Html,
  Icons,
  Layout,
  LazyComponent,
  Modal,
  Overlay,
  PopOver,
  Radios,
  Range,
  Rating,
  // RichText,
  Select,
  SparkLine,
  Spinner,
  Switch,
  Textarea,
  TitleBar,
  ToastComponent,
  toast,
  Tooltip,
  TooltipWrapper,
  Tree,
  Transfer,
  TabsTransfer,
  ListCheckboxes,
  TableCheckboxes,
  TreeCheckboxes,
  ChainedCheckboxes,
  ResultBox,
  InputBox,
  ListRadios,
  SearchBox,
  TreeRadios,
  ListGroup,
  NumberInput,
  ArrayInput,
  AnchorNav
};
